import patchPinnedViews from "./patch-pinned-views"
import PinsCollection from "../../model2/pin/pins"
import SessionEventProto from "../session-event-proto"
import asyncSessionLoader from "../../gd/data/async-session-loader"
import Pin from "../../model2/pin/pin";

export default class EventPinsReset extends SessionEventProto {
    constructor(sessionEvent: any) {
        super(sessionEvent)
    }

    async process() {
        const projects: ID[] = []
        const users: ID[] = []

        this.data.map((pin: any)=>{
            if (pin.project) projects.push(pin.project.id)
            if (pin.user) users.push(pin.user.id)
        })

        await asyncSessionLoader(gd.session.findMissing({
            projects    : projects,
            users       : users
        }))

        gd.session.pins.resetFromJson(this.data)

        patchPinnedViews()
    }
}
